var map = {
	"./bottom.svg": "b560",
	"./dianhua.svg": "ae09",
	"./ditu.svg": "2703",
	"./left.svg": "ab66",
	"./tel.svg": "c27a",
	"./youxiang.svg": "ae63",
	"./zuoji.svg": "0add"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2349";